import axios from "axios";
import PubSub from "pubsub-js";
import { autoLogout } from "./utils/autoLogout";

const runtimeEnv =
  typeof window !== "undefined" && window.__ENV__
    ? window.__ENV__.REACT_APP_API_BASE_URL
    : undefined;

const runtimeFilesEnv =
  typeof window !== "undefined" && window.__ENV__
    ? window.__ENV__.REACT_APP_FILES_BASE_URL
    : undefined;

const baseURL =
  runtimeEnv ||
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === "development"
    ? "http://localhost:4000/api"
    : "/api");

const axiosInstance = axios.create({
  baseURL,
});

const filesBaseURL =
  runtimeFilesEnv ||
  process.env.REACT_APP_FILES_BASE_URL ||
  (process.env.NODE_ENV === "development"
    ? "http://localhost:9000"
    : "/files");

axiosInstance.static = (url) => {
  if (!url) return null;
  if (/^https?:\/\//i.test(url)) return url;
  const sanitized = url
    .replace(/^api\/static\//i, "")
    .replace(/^api\/files\//i, "")
    .replace(/^files\//i, "")
    .replace(/^static\//i, "")
    .replace(/^\/+/, "");
  const base = filesBaseURL.replace(/\/+$/, "");
  return `${base}/${sanitized}`;
};

axiosInstance.interceptors.response.use(
  (rep) => rep,
  (error) => {
    // Ignore les requêtes annulées pour éviter les redirections/notifications inutiles.
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    // If there's no response the server didn't respond (network or CORS),
    // redirect to a 404 page and reject the promise so callers hit .catch.
    if (!error.response) {
      window.location.pathname = "/404";
      return Promise.reject(error);
    }

    // Si 401 ou erreur "invalid token", déconnexion automatique
    if (
      error.response.status === 401 ||
      (error.response.data &&
        (error.response.data.errors === "invalid token" ||
          (Array.isArray(error.response.data.errors) &&
            error.response.data.errors.includes("invalid token"))))
    ) {
      autoLogout();
      return Promise.reject(error);
    }

    // Forbidden: notify user and reject the promise
    if (error.response.status === 403) {
      PubSub.notif({
        txt: "Vous n'avez pas les droits suffisants pour effectuer cette action.",
        color: "danger",
      });
      return Promise.reject(error);
    }

    // For all other error cases, reject the promise so callers receive a
    // rejected promise instead of a resolved value which could be misinterpreted.
    return Promise.reject(error);
  }
);

export default axiosInstance;
